import React from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Row,
  Col,
  Radio,
  FormGroup,
} from 'react-bootstrap';
import {
  goBack, MainComponentBox, locationFallThrough,
  locationFallThroughClear,
} from '../../../../util/util.jsx';
import Label from '@/component/form/Label.jsx';
import FancyInput from '@/component/form/numinput/index.jsx';
import { handleFormChanged } from '@/store/allaround.store.js';
import Quantity from '../elements/Quantity.jsx';
import ElementBuilder from '../elements/ElementBuilder.jsx';
import SmallTransportDisplay from '../transport/SmallTransportDisplay.jsx';
import { getDealListWrapper } from '../store/DealsWrapper';
import _ from 'lodash';
import { fromJS, List, Set, Map } from 'immutable';
import { alterProduct, addTransportToLink } from '../store/deal.store.js';
import { calculateUnlinkedObject, formatQuantity, formatNumber } from '../elements/BaseElement';
import { linkCreated, stopLinking } from '../../../../store/links.store';
import AlertPopover from '@/util/AlertPopover.jsx';
import PurchaseSaleElement from '../elements/PurchaseSaleElement';
import PlaceNameDisplayWrapper from '@/component/dict/simple/port/NameDisplayWrapper';
import { LinkHeader } from './LinkHeader';
import { getTransportPorts, threeSideValidation } from './LinkValidationFuncs.js';
import { getSimpleListWrapper } from '@/component/dict/simple/SimpleWrapper';
import { saveSelectedAtoms, clearQuantity, saveSelectedLinks } from '@/store/links.store.js';
import {
  REF_NAME as DT_REF_NAME,
  REF_PATH as DT_REF_PATH,
} from '@/component/dict/simple/deliveryterm/Const';
import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';
import Atoms from '../Atoms';

moment.locale('en');
momentLocalizer();

const momentDate = (strDate) => moment(strDate, 'DD MMM YYYY');

class BlQuantity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <div style={{ paddingTop: 5, display: 'flex', marginBottom: '-15px' }}>
          <Label
            label="B/L quantity "
            sm={5}
            style={{ paddingTop: 9 }}
            childStyle={{ width: '50%' }}
          >
            <FancyInput
              onChange={(e, v) => {
                const actualBlq = parseFloat(v);
                this.setState({ failed: actualBlq > this.props.blq });
                this.props.onChangeFunc(actualBlq, actualBlq > this.props.blq);
              }}
              className="form-control"
              thousand
              fraction={3}
              positive
              negative={false}
              type="number"
              id="BLQuantityInput" name="BLQuantityInput"
            />
          </Label>
        </div>
        {this.state.failed &&
          <div style={{ textAlign: 'center', color: 'red' }}>
            Error! There is not enough quantity to link
          </div>
        }
      </div>
    );
  }
}

BlQuantity.propTypes = {
  blq: React.PropTypes.number,
  onChangeFunc: React.PropTypes.func,
};

// eslint-disable-next-line
class TransportLinksEdit extends React.Component {
  constructor(props) {
    super(props);
    this.stepBack = this.stepBack.bind(this);
    this.updateQuantity = this.updateQuantity.bind(this);
    this.updateTransport = this.updateTransport.bind(this);
    this.save = this.save.bind(this);
    this.updateSaveAllowed = this.updateSaveAllowed.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.getDataToDisplay = this.getDataToDisplay.bind(this);
    this.findLinkedDeal = this.findLinkedDeal.bind(this);
    this.handleHalfLinkProductSelected = this.handleHalfLinkProductSelected.bind(this);
    this.handleNewLinkSelected = this.handleNewLinkSelected.bind(this);
    this.captionAddon = this.captionAddon.bind(this);
    this.footerAddon = this.footerAddon.bind(this);
    this.transportFailed = true;
    this.quantityFailed = false;
    // eslint-disable-next-line
    this.createdata = this.props.linkToAssignIdx === undefined ? true : false;
    if (props.product) {
      this.state = {
        saveAllowed: false, data: {}, alerts: new Map(), alertMsg: '',
        unlinkedObject: calculateUnlinkedObject(props.product), hostElementToShow: new Map(),
        transports: new Map(),
        newLink: true,
      };
    } else {
      this.state = {
        saveAllowed: false, data: {}, alerts: new Map(), alertMsg: '',
        transports: new Map(),
      };
    }
    this.state.oddData = [];
    this.state.showOdd = false;
  }

  componentWillMount() {
    getDealListWrapper('transport', 'INF');
    getDealListWrapper(this.props.dealFrom, 'INF');
    getDealListWrapper(this.props.dealTo, 'INF');
    getSimpleListWrapper(DT_REF_NAME, DT_REF_PATH);
    locationFallThrough('New link', '', 'DEAL_LINK', this.stepBack);
    this.props.saveSelectedAtoms(new Map());
    this.props.saveSelectedLinks(new Map());
  }

  componentDidMount() {
    this.transportFailed = true;
    this.quantityFailed = false;
    this.createHostElement(this.props);
    this.filterTransport(this.props);
  }

  componentWillReceiveProps(props) {
    if (props.product) {
      this.setState({ unlinkedObject: calculateUnlinkedObject(props.product) });
    }
    if ((props.transportList && props.transportList != this.props.transportList)
      || (props.product && this.props.product != props.product)) {
      this.filterTransport(props);
    }
    this.createHostElement(props);
    // eslint-disable-next-line
    this.createdata = props.linkToAssignIdx === undefined ? true : false;
  }

  getDataToDisplay(data, initialIdx = 0) {
    return (
      data.map((elem, idx) =>
        <div key={initialIdx + idx} style={{ marginBottom: '5px', display: 'flex' }}>
          {this.state.alerts.get(`transport_${initialIdx + idx}`) ?
            <AlertPopover
              data={this.state.alerts.get(`transport_${initialIdx + idx}`)}
              target={`transport_${initialIdx + idx}`}
              placement={this.createdata ? 'left' : undefined}
              hideAlert={this.hideAlert}
              show={this.state.showAlert}
            />
            : ''}
          <Col xs={1} style={{ display: 'flex', alignItems: 'center' }}>
            <Radio
              inline name="transportRadio" id={`transportAssignment_${initialIdx + idx}`}
              checked={this.state.data && elem.get('id') == this.state.data.transport}
              onChange={(e) => this.updateTransport(elem, initialIdx + idx, e)}
            />
          </Col>
          <Col
            xs={11}
            id={`transport_${initialIdx + idx}`}
            onClick={(e) => this.updateTransport(elem, initialIdx + idx, e)}
            style={{ cursor: 'pointer' }}
          >
            <SmallTransportDisplay transportId={elem.get('id')} viewMode disableOnClick linkMode />
          </Col>
        </div>)
    );
  }

  createHostElement(props) {
    if (props.product && props.dealFromList) {
      let hostDeal = props.dealFromList
        .find(deal => deal.get('id') == props.product.get(props.dealFrom));
      if (!hostDeal) {
        hostDeal = new Map();
      }
      const dealToShow = hostDeal.set('products', List.of(props.product));
      const hostElementToShow = (<PurchaseSaleElement
        dealType={props.dealFrom}
        data={dealToShow} noControlls noStatus hideLinks mode="parentatom"
      />);
      this.setState({ hostElementToShow });
    }
    return new Map();
  }

  addLink() {
    let data = fromJS(this.state.halfLinkData ? this.state.halfLinkData : this.state.data)
      .set(this.props.dealFrom, this.props.product.get(this.props.dealFrom))
      .set(`${this.props.dealFrom}Product`, this.props.product.get('id'))
      .set(`${this.props.dealFrom}ProductType`, this.props.product.get('productType'));
    if (this.props.multiNodalQuantity) {
      data = data.set('fromMultiNodal', true)
        .set('multiNodalQuantity', this.props.multiNodalQuantity);
    }
    let productLinks = this.props.product.get(`${this.props.dealFrom}Link`) || new List();
    productLinks = productLinks.push(data);
    this.props.alterProduct(this.props.productToLinkIdx,
      this.props.product.set(`${this.props.dealFrom}Link`, productLinks));
    this.props.linkCreated(this.props.dealFrom, this.props.productToLinkIdx,
      fromJS([data]), productLinks);
  }

  filterTransport(props) {
    const transports = props.transportList;
    const doFilter = (t, additionalFilter = true) => {
      if (t.get('isArchived')) {
        return false;
      }

      const { product } = props;

      if (!product) {
        return false;
      }
      const productTransportType = product.get('transportType');
      if (productTransportType) {
        if (productTransportType != t.get('transportType')) {
          return false;
        }
      }

      if (!additionalFilter) {
        return true;
      }
      // Не показывать транспорты, у которых хоть в одном линке есть БЛ
      if (t.get('links', new List()).some(l => l.get('billLandingQuantity')
        && l.get('billLandingQuantity') > 0)) {
        return false;
      }

      let filtered = true;
      if (t.get('transportType') == 'BULK' && product) {
        // Дополнительное требовнаие для Bulk Vessel :
        // 1. если есть дата в Shipment date , то показвает транспорт у которого:
        const shipmentFrom = product.get('shipmentFrom');
        const shipmentTo = product.get('shipmentTo');
        if (shipmentFrom && shipmentTo) {
          let transportLaycanStart = new List();
          let transportLaycanEnd = new List();
          const vesselPortName = props.dealFrom == 'purchase' ?
            'vesselLoadingPorts' : 'vesselDischargePorts';
          t.get(vesselPortName, new List()).forEach((p, idx) => {
            const loadingPort = t.getIn(['vesselLoadingPorts', idx], new List());
            transportLaycanStart = transportLaycanStart.push(loadingPort.get('laycanStart'));
            transportLaycanEnd = transportLaycanEnd.push(loadingPort.get('laycanEnd'));
          });
          transportLaycanStart = transportLaycanStart.filter(l => l != null);
          transportLaycanEnd = transportLaycanEnd.filter(l => l != null);
          if (transportLaycanStart.isEmpty() || transportLaycanEnd.isEmpty()) {
            filtered = true;
          } else {
            filtered = transportLaycanStart.concat(transportLaycanEnd).some(ld => {
              const laycanDate = momentDate(ld).toDate();
              return (laycanDate >= momentDate(shipmentFrom).add(-1, 'M').toDate()
                && laycanDate <= momentDate(shipmentFrom).add(1, 'M').toDate())
                || (laycanDate >= momentDate(shipmentTo).add(-1, 'M').toDate()
                  && laycanDate <= momentDate(shipmentTo).add(1, 'M').toDate());
            });
          }
        }
        // 2. если отсутствует дата Shipment date , то показываем все транспорта.
      }
      return filtered && this.filterTransportByProduct(t, product);
    };
    if (transports && transports.size > 0) {
      const filteredTransports = transports.filter(t => doFilter(t, true));
      const filteredIds = filteredTransports.map(elem => elem.get('id')).toJS();
      this.setState({
        transports: filteredTransports,
        oddData: transports.filter(t => doFilter(t, false))
          .filter(t => !filteredIds.includes(t.get('id'))),
      });
    }
  }

  filterTransportByProduct(transport, product) {
    if (!product) {
      return false;
    }
    const productId = product.get('product');
    const productTypeId = product.get('productType');
    const found = transport.get('linkedProducts', new List()).find(p => p == productId);
    return found || found === 0
      || transport.get('links', new List())
        .some(l => l.get('saleProductType') == productTypeId
          || l.get('purchaseProductType') == productTypeId);
  }

  hideAlert() {
    this.setState({ showAlert: false, alertMsg: '' });
  }

  stepBack() {
    locationFallThroughClear('DEAL_LINK');
    this.props.stopLinking();
    if (this.props.linkingFromList) {
      this.props.goBack();
    }
  }

  save() {
    if (this.createdata) {
      this.addLink();
    } else {
      this.props.addTransportToLink(this.props.productToLinkIdx, this.props.linkToAssignIdx,
        this.state.data.transport, this.state.data.freightAmount);
    }
    if (this.props.linkingFromList) {
      this.props.saveLinkingFromList();
    }
    this.props.stopLinking();
    locationFallThroughClear('DEAL_LINK');
  }

  updateQuantity(quantityObject) {
    const updatedLink = Object.assign({},
      this.state.data,
      _.pick(quantityObject,
        ['quantity', 'quantityMin', 'quantityMinP', 'quantityMaxP', 'quantityMax']));
    this.setState({ data: updatedLink });
    if (quantityObject.failed) {
      this.quantityFailed = true;
    } else {
      this.quantityFailed = false;
    }
    this.props.handleFormChanged();
    this.updateSaveAllowed();
  }

  updateTransport(elem, idx, e) {
    if (e) {
      e.stopPropagation();
    }
    const id = elem.get('id');
    if (this.state.data && this.state.data.transport === id) {
      return;
    }
    const halfLinks = elem.get('links', new List()).filter(link => {
      const fromProduct = link.get(`${this.props.dealFrom}Product`);
      const toProduct = link.get(`${this.props.dealTo}Product`);
      return fromProduct == null && (toProduct || toProduct === 0);
    });
    this.transportFailed = false;
    this.setState({
      data:
        { ...this.state.data, transport: id, freightAmount: elem.get('freightAmount') },
      halfLinks,
      newLink: true,
    });
    this.validate(elem, idx);
    this.props.handleFormChanged();
    this.updateSaveAllowed();
  }

  validate(elem, idx) {
    let threeSideValidationResult = false;
    const productPorts = Array.isArray(this.props.product.get('ports')) ?
      new List().merge(this.props.product.get('ports')) :
      this.props.product.get('ports', new List());
    const firstAlert = this.validatePort(productPorts, elem, idx, this.props.dealFrom);
    let secondAlert = '';
    if (this.props.link.get(`${this.props.dealTo}Id`)
      || this.props.link.get(`${this.props.dealTo}Id`) === 0) {
      const oppositeProduct = this.props.linkToAssignIdx === undefined ? undefined
        : this.props.dealToList
        // eslint-disable-next-line
          .find(deal => deal.get('id') == this.props.link.get(`${this.props.dealTo}Id`), Map())
          // eslint-disable-next-line
          .get('products', List())
          .find(prd => prd.get('id') == this.props.link.get(`${this.props.dealTo}Product`));
      if (oppositeProduct) {
        threeSideValidationResult = threeSideValidation(this.props.deliveryTerms,
          this.props.dealFrom == 'purchase' ? this.props.product : oppositeProduct,
          this.props.dealFrom != 'purchase' ? this.props.product : oppositeProduct,
          elem);
        if (!threeSideValidationResult !== false) {
          const oppositeProductPorts = Array.isArray(oppositeProduct.get('ports')) ?
            new List().merge(oppositeProduct.get('ports')) :
            oppositeProduct.get('ports', new List());
          secondAlert = this.validatePort(oppositeProductPorts, elem, idx, this.props.dealTo);
        }
      }
    }
    let alert = undefined;

    if (threeSideValidationResult !== false) {
      alert = threeSideValidationResult;
    } else if (firstAlert || secondAlert) {
      alert = (<div>
        {firstAlert}
        {secondAlert ?
          <div style={{ marginTop: '6px' }}>
            {secondAlert}
          </div> : ''
        }
      </div>);
    }
    let alerts = this.state.alerts.clear();
    if (alert) {
      alerts = this.state.alerts.clear().set(`transport_${idx}`, alert);
    }
    this.setState({ alerts, showAlert: alert !== undefined });
  }

  validatePort(productPorts, elem, idx, dealFrom) {
    const compareTo = getTransportPorts(elem, dealFrom);

    const portTypeLabel = dealFrom === 'purchase' ? 'loading' : 'discharge';
    const portTypeLabelUppercase = dealFrom === 'purchase' ? 'Loading' : 'Discharge';
    const dealType = dealFrom === 'purchase' ? 'Purchase' : 'Sale';
    let alert = '';
    if (!(!productPorts || productPorts.size == 0 || !compareTo || compareTo.size == 0) &&
      productPorts.filter(port => compareTo.indexOf(port) > -1).size === 0) {
      // eslint-disable-next-line
      alert = (<div>
        <Row>
          <Col xs={12}>
            {portTypeLabelUppercase} ports mismatch:
          </Col>
          <Col xs={12}>
            {dealType} ports: {productPorts.map((port, idxPort) =>
              <div key={idxPort}>
                <PlaceNameDisplayWrapper
                  id={port}
                />
                {idxPort + 1 < productPorts.size ? ', ' : ''}
              </div>)}
          </Col>
          <Col xs={12}>
            Transport {portTypeLabel} ports:
            {compareTo.map((port, idxPort) =>
              <div key={idxPort}>
                <PlaceNameDisplayWrapper
                  id={port}
                />
                {idxPort + 1 < compareTo.size ? ', ' : ''}
              </div>)
            }
          </Col>
        </Row>
      </div>);
    }
    return alert;
  }

  updateSaveAllowed() {
    if (!this.quantityFailed && !this.transportFailed) {
      this.setState({ saveAllowed: true });
    } else {
      this.setState({ saveAllowed: false });
    }
  }

  findLinkedDeal(props = this.props) {
    const dealList = props.dealToList;
    const link = props.link;
    if (!link || !dealList) {
      return '';
    }
    let deal = dealList.find(d => d.get('id') == link.get(`${props.dealTo}Id`));
    if (!deal) {
      return '';
    }
    deal = deal.set('products', deal.get('products')
      .filter(p => p.get('id') == link.get(`${props.dealTo}Product`)));
    return (<ElementBuilder
      data={deal}
      mode="parentatom"
      type={`connect${props.dealTo}`}
      key="linkeddeal"
      rowStyle={{ marginTop: 0 }}
    />);
  }

  handleHalfLinkProductSelected(dealIdx, id, data, prod, link) {
    if (this.state.selectedId !== data.get('id') || this.state.selectedLink !== link.get('id')) {
      this.props.saveSelectedAtoms(new Map().set(id, Set.of(data.get('id'))));
      this.props.saveSelectedLinks(new Map().set(id, Set.of(link.get('id'))));
      this.props.clearQuantity();
      this.setState({
        newLink: false, selectedId: data.get('id'), selectedLink: link.get('id'), halfLinkData: {
          [`${this.props.dealTo}Id`]: data.get(this.props.dealTo),
          [`${this.props.dealTo}Product`]: data.get('id'),
          [`${this.props.dealTo}ProductType`]: data.get('productType'),
          [`${this.props.dealTo}Packing`]: data.get('packing'),
          transport: this.state.data.transport,
          freightAmount: this.state.data.freightAmount,
        } });
      this.quantityFailed = false;
      this.updateSaveAllowed();
    }
  }

  handleNewLinkSelected() {
    if (this.state.selectedId !== 'new') {
      this.props.saveSelectedAtoms(new Map());
      this.props.saveSelectedLinks(new Map());
      this.props.clearQuantity();
      this.setState({ newLink: true, selectedId: 'new', halfLinkData: null });

      this.quantityFailed = false;
      this.updateSaveAllowed();
    }
  }

  captionAddon(atomId, link) {
    if (link) {
      const blq = link.get('billLandingQuantity');
      return (
        <div>
          <div style={{ float: 'left' }}>Existing link</div>
          {blq ?
            <div style={{ float: 'right' }}>
              <b className="text-danger">B/L qty</b> {formatNumber(blq)}
            </div>
            :
            <div style={{ float: 'right' }}>
              <b className="text-danger">Quantity</b> {formatQuantity(link, true)}
            </div>
          }
        </div>
      );
    }
    return null;
  }

  footerAddon(atom, link, selected) {
    if (selected) {
      const atomId = atom.get('id');
      if (link) {
        const blq = link.get('billLandingQuantity');
        if (blq) {
          return (
            <BlQuantity
              blq={blq}
              onChangeFunc={(value, status) => {
                this.quantityFailed = status;
                this.updateSaveAllowed();
                this.setState({ halfLinkData: {
                  ...this.state.halfLinkData,
                  billLandingQuantity: value,
                  fromHalfLink: link.get('id'),
                } });
              }}
            />
          );
        }
        return (
          <div style={{ paddingTop: '15px' }}>
            <Quantity
              id={atomId}
              onChangeFunc={(qo) => {
                this.quantityFailed = qo.failed;
                this.updateSaveAllowed();
                this.setState({ halfLinkData: {
                  ...this.state.halfLinkData,
                  quantity: qo.quantity,
                  quantityMin: qo.quantityMin,
                  quantityMax: qo.quantityMax,
                  quantityMaxP: qo.quantityMaxP,
                  quantityMinP: qo.quantityMinP,
                  fromHalfLink: link.get('id'),
                } });
              }}
              dealType={this.props.dealTo}
              data={new Map()}
              isLinking
              link={link.toJS()}
              unlinkedObject={link.toJS()}
            />
          </div>);
      }
    }
    return null;
  }

  render() {
    const header = (<LinkHeader
      caption={'New transport assignment'}
      disabled={!this.state.saveAllowed}
      stepForward={this.save}
      stepBack={this.stepBack}
    />);
    const linkedDeal = this.findLinkedDeal(this.props);
    const transports = (<Col xs={12}>
      <FormGroup>
        {this.state.transports ? this.getDataToDisplay(this.state.transports) : ''}
        {this.state.oddData && this.state.showOdd ?
          this.getDataToDisplay(this.state.oddData, this.state.transports.size) : ''}
        {this.state.oddData.size && !this.state.showOdd ?
          <Row>
            <Col
              mdOffset={5} md={4}
              style={{ paddingTop: '10px', textAlign: 'center' }}
            >
              <Button
                bsStyle={'primary'}
                onClick={() => this.setState({ showOdd: true })}
              >Show more</Button>
            </Col>
          </Row>
          :
          ''
        }
      </FormGroup>
    </Col>);
    const quantity = (
      <div>
        <Row>
          <Col
            xs={1} style={{ display: 'flex', justifyContent: 'center',
              alignItems: 'center', paddingRight: '3px', height: '1em', marginRight: '-13px' }}
          >
            <Radio
              name="dealRadio"
              inline
              checked={this.state.newLink}
              onChange={this.handleNewLinkSelected}
            />
          </Col>
          <Col xs={11} style={{ paddingRight: 0 }}>
            <Quantity
              updateOnNewProps
              dealType={'transport'}
              id={'new'}
              multiNodalQuantity={this.props.multiNodalQuantity}
              onChangeFunc={(e) => this.updateQuantity(e)} data={new Map()}
              unlinkedObject={this.state.unlinkedObject} isLinking
              shrinked={!this.state.newLink}
              handleSelected={this.handleNewLinkSelected}
            />
          </Col>
        </Row>
        {this.props.product &&
          <Row className="transport-existing-link">
            <Atoms
              dealTo={this.props.dealTo}
              dealFrom={this.props.dealFrom}
              selectMode="radio"
              noEmptyValidattion
              showLinks
              filterBy={new Map({
                product: this.props.product.get('product'),
                productIds: (this.state.halfLinks || new List())
                  .map(halfLink => halfLink.get(`${this.props.dealTo}Product`)),
              })}
              handleSelected={this.handleHalfLinkProductSelected}
              captionAddon={this.captionAddon}
              footerAddon={this.footerAddon}
            />
          </Row>
        }
      </div>);
    return (
      <MainComponentBox secondNavBar={header} style={{ padding: '0px 40px 0 20px' }} withBreadcrumb>
        <Row style={{ marginTop: 30, fontSize: 13 }} className="transport-linking">
          <Col xs={4}>
            <Row
              style={{
                position: 'fixed',
                padding: 'inherit',
                margin: 'inherit',
                right: '67%',
                width: '32%',
              }}
            >
              <Col xs={12}>
                {// eslint-disable-next-line
                  !this.createdata && this.props.dealFrom == 'sale' ?
                    linkedDeal : !this.createdata ? this.state.hostElementToShow : ''}

                {// eslint-disable-next-line
                  this.createdata && this.props.dealFrom == 'purchase' ?
                    this.state.hostElementToShow : this.createdata ? quantity : ''}
              </Col>
            </Row>
          </Col>
          <Col xs={4}>
            <Row>
              {transports}
            </Row>
          </Col>
          <Col xs={4}>
            <Row
              style={{
                position: 'fixed',
                padding: 'inherit',
                margin: 'inherit',
                width: '32%',
              }}
            >
              <Col xs={12}>
                {// eslint-disable-next-line
                  !this.createdata && this.props.dealFrom == 'purchase' ?
                    linkedDeal : !this.createdata ? this.state.hostElementToShow : ''}

                {// eslint-disable-next-line
                  this.createdata && this.props.dealFrom == 'sale' ?
                    this.state.hostElementToShow : this.createdata ? quantity : ''}
              </Col>
            </Row>
          </Col>
        </Row>
      </MainComponentBox>
    );
  }
}

TransportLinksEdit.propTypes = {
  connect: React.PropTypes.func,
  goBack: React.PropTypes.func,
  stopLinking: React.PropTypes.func,
  handleFormChanged: React.PropTypes.func,
  dealTo: React.PropTypes.string,
  dealFrom: React.PropTypes.string,
  transportList: React.PropTypes.object,
  product: React.PropTypes.object,
  alterProduct: React.PropTypes.func,
  productToLinkIdx: React.PropTypes.number,
  linkToAssignIdx: React.PropTypes.number,
  addTransportToLink: React.PropTypes.func,
  dealFromList: React.PropTypes.object,
  dealToList: React.PropTypes.object,
  link: React.PropTypes.object,
  saveLinkingFromList: React.PropTypes.func,
  linkingFromList: React.PropTypes.bool,
  productToLinkId: React.PropTypes.number,
  deliveryTerms: React.PropTypes.object,
  saveSelectedAtoms: React.PropTypes.func.isRequired,
  saveSelectedLinks: React.PropTypes.func.isRequired,
  clearQuantity: React.PropTypes.func.isRequired,
  multiNodalQuantity: React.PropTypes.number,
  linkCreated: React.PropTypes.func.isRequired,
};

export default connect((state, props) => {
  const prod = state.getIn(['links', 'data', 'productToLinkIdx']) !== undefined
    ? state.getIn(['data', 'deals', 'deal', 'products'], new List())
      .get(state.getIn(['links', 'data', 'productToLinkIdx']))
    : undefined;
  const linkIdx = state.getIn(['links', 'data', 'linkIdx']);
  const link = prod ?
    prod.get(`${props.dealFrom}Link`, new List()).get(linkIdx, new Map()) : new Map();
  return {
    transportList: state.getIn(['data', 'deals', 'list', 'transport'], new List()),
    productToLinkIdx: state.getIn(['links', 'data', 'productToLinkIdx']),
    productToLinkId: state.getIn(['links', 'data', 'productId']),
    linkToAssignIdx: linkIdx,
    link,
    product: prod,
    dealFromList: state.getIn(['data', 'deals', 'list', props.dealFrom]),
    dealToList: state.getIn(['data', 'deals', 'list', props.dealTo]),
    linkingFromList: state.getIn(['links', 'data', 'fromList'], false),
    deliveryTerms: state.getIn(['references', 'simple', DT_REF_PATH], new List()),
  };
},
(dispatch) => ({
  goBack() {
    goBack();
  },
  handleFormChanged() {
    handleFormChanged(dispatch);
  },
  alterProduct(idx, data) {
    alterProduct(dispatch, idx, data);
  },
  linkCreated(dealFrom, productIdx, links, allLinks) {
    linkCreated(dispatch, dealFrom, productIdx, links, allLinks);
  },
  stopLinking() {
    stopLinking(dispatch);
  },
  addTransportToLink(productIdx, linkIdx, transportId, freightAmount) {
    addTransportToLink(dispatch, productIdx, linkIdx, transportId, freightAmount);
  },
  saveSelectedAtoms: (atoms) => {
    saveSelectedAtoms(dispatch, atoms);
  },
  saveSelectedLinks: (links) => {
    saveSelectedLinks(dispatch, links);
  },
  clearQuantity: () => {
    clearQuantity(dispatch);
  },
}))(TransportLinksEdit);
